import { Injectable } from '@angular/core';
import { AbstractOfflineStorageAsyncTimestampService } from '../abstract/abstract-offline-storage-async-timestamp.service';
import { ImmoIPImmoTaskChangesObject } from './immo-ip-immo-task-changes-object';
import { ExpiredImmoIPImmoTaskChangesRemover } from './expired-immo-ip-immo-task-changes-remover';
import { NgForage } from 'ngforage';
import { NgForageTimestampService } from '../../ng-forage/ng-forage-timestamp.service';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import AssetHelper from 'src/app/helpers/asset-helper';

@Injectable({
  providedIn: 'root',
})
export class ImmoIPImmoTaskChangesService extends AbstractOfflineStorageAsyncTimestampService<
  number,
  ImmoIPImmoTaskChangesObject,
  ExpiredImmoIPImmoTaskChangesRemover
> {
  constructor(
    protected ngForage: NgForage,
    protected ngForageTimestampService: NgForageTimestampService
  ) {
    super(
      'immo-ip-immo-task-change-',
      'immo-ip-immo-task-changes',
      ngForage,
      ngForageTimestampService
    );
  }

  protected instantiateRemover(): ExpiredImmoIPImmoTaskChangesRemover {
    return new ExpiredImmoIPImmoTaskChangesRemover(
      this,
      this.ngForage,
      this.ngForageTimestampService
    );
  }

  // Override
  protected verifyToStoreObject(object: ImmoIPImmoTaskChangesObject): void {
    if (object == null || object.id == null) {
      throw new Error(
        'immoIPImmoTaskChangesObject must not be null and id must not be null'
      );
    }
  }

  public convertToID(o: any): number {
    const toReturn = GeneralHelper.isNumeric(o) ? o : Number(o);
    if (!GeneralHelper.isNumeric(toReturn)) {
      throw new Error(`${o} could not be converted to number`);
    }
    return toReturn;
  }

  protected stringifyID(id: number): string {
    return id.toString();
  }

  // Override
  public async cleanupOfflineObject(
    object: ImmoIPImmoTaskChangesObject
  ): Promise<void> {
    if (object == null) {
      return;
    }
    if (CollectionHelper.isPopulated(object.offlineAssets)) {
      await Promise.all(
        object.offlineAssets.map((offlineAsset) =>
          this.ngForage.removeItem(
            AssetHelper.getStorageKeyFor(offlineAsset.localFileUuid)
          )
        )
      );
    }
  }
}
